export default {"src":"/_next/static/media/ico-search.e885bb9f.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};